import React from 'react';
import { connect } from 'react-redux';
import SearchAuthor from './SearchAuthor';
import CheckBoxFilter from '../../common/components/_CheckboxFilter';
import { getSearch, toggleSearch } from '../../common/services/selectors';
import SearchAccordianToggle from './SearchAccordianToggle';

function SearchTecnicalFilter({ search, filter, toggle, store }) {
	let techArr = ['0/403/440', '0/403/409'];
	return (
		<div>
            {/*
             *<hr />
			{filter.taxonomyPathFilters && 
				filter.taxonomyPathFilters.ContentCategory && 
                techArr.map((key) => {
					let taxItem = filter.taxonomyPathFilters.ContentCategory.children.filter(tax => tax.key == key);
					return <CheckBoxFilter key={key} search={search} node={taxItem[0]} filter='contentCategory' />
				})}
                */}
                {/*<SearchAccordianToggle search={search} store={store} toggle={toggle} filter={filter} />*/}
				<SearchAuthor search={search} />
		</div>
	);
}

const mapStateToProps = state => ({ search: getSearch(state), toggle: toggleSearch(state) });

export default connect(mapStateToProps)(SearchTecnicalFilter);